<template>
  <v-field :label='label' :error='errors.first(name)' :tooltip='tooltipMsg'>
    <masked-input
      :disabled="$can.not('edit-exploitation')"
      v-bind='$attrs'
      :name='name'
      :value='parsedValue'
      @input='processInput'
      mask="11 / 11"
      placeholder="dd / MM"/>
  </v-field>
</template>

<script>
import mixinTooltip from '@/mixins/tooltip'
import maskedInput from 'vue-masked-input'
import { DateTime } from 'luxon'

export default {
  name: 'FieldDate',
  mixins: [mixinTooltip],
  inject: ['$validator'],

  inheritAttrs: false,

  components: {
    maskedInput
  },

  props: {
    value: String,
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: 'notDefined'
    }
  },

  computed: {
    parsedValue () {
      if (!this.value) {
        return null
      }
      let date = DateTime.fromFormat(this.value, 'yyyy-MM-dd')
      if (date.isValid) {
        return date.toFormat('dd / MM')
      }
      return null
    }
  },

  methods: {
    processInput (inputValue, rawValue) {
      if (rawValue.length === 0) {
        console.log('field date emit null')
        this.$emit('input', null)
        return
      }
      let date = DateTime.fromFormat(inputValue + ' / 2019', 'dd / MM / yyyy')
      if (date.isValid) {
        console.log('field date emit ', date.toFormat('yyyy-MM-dd'))
        this.$emit('input', date.toFormat('yyyy-MM-dd'))
      }
    }
  }
}
</script>
